module.exports = __webpack_public_path__ + "img/studiopro_login.46d12d3e.png";